import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find-index";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import Color from 'color';
import { validateColor } from './validateColor';
import { toLowerCase } from './convertLetters';
export var colorFormat = function colorFormat(colorStr) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var outType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'all';
  var formatHex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var ColorTools = Color(getColorObj(colorStr)).alpha(alpha);
  var toHex = function toHex() {
    if (/^#([0-9a-fA-F]{8})$/.test(colorStr)) {
      if (formatHex) {
        return toLowerCase(alpha === 1 ? ColorTools.hex() : ColorTools.hexa());
      } else {
        return colorStr;
      }
    } else {
      return toLowerCase(alpha === 1 ? ColorTools.hex() : ColorTools.hexa());
    }
  };
  var HEX = toHex();
  var HSB = colorToStr(ColorTools.hsv());
  var RGB = ColorTools.rgb().string();
  var HSL = colorToStr(ColorTools.hsl());
  if (outType === 'HEX') return HEX;
  if (outType === 'HSB') return HSB;
  if (outType === 'HSL') return HSL;
  if (outType === 'RGB') return RGB;
  if (outType === 'all') {
    return [{
      type: 'HEX',
      value: HEX
    }, {
      type: 'HSB',
      value: HSB
    }, {
      type: 'RGB',
      value: RGB
    }, {
      type: 'HSL',
      value: HSL
    }];
  }
};
export var getColorObj = function getColorObj(colorStr) {
  var colorArray = colorStr.split(',');
  var type = validateColor(colorStr);
  if (type === 'HSB' || type === 'HSBA') {
    var s = removePercentage(colorArray[1]);
    if (type === 'HSB') {
      var h = colorArray[0].replace('hsb(', '');
      var b = colorArray[2].replace(')', '');
      return {
        h: h,
        s: s,
        v: removePercentage(b)
      };
    } else {
      var _h = colorArray[0].replace('hsba(', '');
      var _b = colorArray[2];
      var a = colorArray[3].replace(')', '');
      return {
        h: +_h,
        s: s,
        v: removePercentage(_b),
        alpha: +a
      };
    }
  } else if (type === 'HSL' || type === 'HSLA') {
    var _s = addPercentage(colorArray[1]);
    if (type === 'HSL') {
      var _context, _context2;
      var _h2 = colorArray[0].replace('hsl(', '');
      var l = colorArray[2].replace(')', '');
      return _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "hsl(".concat(_h2, ",")).call(_context2, _s, ",")).call(_context, addPercentage(l), ")");
    } else {
      var _context3, _context4, _context5;
      var _h3 = colorArray[0].replace('hsla(', '');
      var _l = colorArray[2];
      var _a = colorArray[3].replace(')', '');
      return _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = _concatInstanceProperty(_context5 = "hsla(".concat(_h3, ",")).call(_context5, _s, ",")).call(_context4, addPercentage(_l), ",")).call(_context3, _a, ")");
    }
  } else if (type === 'RGB' || type === 'RGBA') {
    var g = colorArray[1];
    if (type === 'RGB') {
      var _context6, _context7;
      var r = colorArray[0].replace('rgb(', '');
      var _b2 = colorArray[2].replace(')', '');
      return _concatInstanceProperty(_context6 = _concatInstanceProperty(_context7 = "rgb(".concat(strFixed(r), ",")).call(_context7, strFixed(g), ",")).call(_context6, strFixed(_b2), ")");
    } else {
      var _context8, _context9, _context10;
      var _r = colorArray[0].replace('rgba(', '');
      var _b3 = colorArray[2];
      var _a2 = colorArray[3].replace(')', '');
      return _concatInstanceProperty(_context8 = _concatInstanceProperty(_context9 = _concatInstanceProperty(_context10 = "rgba(".concat(strFixed(_r), ",")).call(_context10, strFixed(g), ",")).call(_context9, strFixed(_b3), ",")).call(_context8, strFixed(_a2, 2), ")");
    }
  } else {
    return colorStr;
  }
};
var addPercentage = function addPercentage(parameter) {
  return (parameter === null || parameter === void 0 ? void 0 : parameter.indexOf('%')) !== -1 ? parameter : +parameter > 0 && +parameter <= 1 ? +parameter * 100 + '%' : parameter + '%';
};
var removePercentage = function removePercentage(parameter) {
  return (parameter === null || parameter === void 0 ? void 0 : parameter.indexOf('%')) !== -1 ? +parameter.replace('%', '') : +parameter > 0 && +parameter <= 1 ? +parameter * 100 : +parameter;
};
var colorToStr = function colorToStr(obj) {
  var arr = obj.color;
  if (obj.valpha === 1) {
    var _context11, _context12, _context13;
    return _concatInstanceProperty(_context11 = _concatInstanceProperty(_context12 = _concatInstanceProperty(_context13 = "".concat(obj.model === 'hsv' ? 'hsb' : 'hsl', "(")).call(_context13, strFixed(arr[0]), ", ")).call(_context12, strFixed(arr[1]), "%, ")).call(_context11, strFixed(arr[2]), "%)");
  } else {
    var _context14, _context15, _context16, _context17;
    return _concatInstanceProperty(_context14 = _concatInstanceProperty(_context15 = _concatInstanceProperty(_context16 = _concatInstanceProperty(_context17 = "".concat(obj.model === 'hsv' ? 'hsba' : 'hsla', "(")).call(_context17, strFixed(arr[0]), ", ")).call(_context16, strFixed(arr[1]), "%, ")).call(_context15, strFixed(arr[2]), "%, ")).call(_context14, strFixed(obj.valpha, 2), ")");
  }
};
export var strFixed = function strFixed(numStr) {
  var num = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return +(+numStr).toFixed(num);
};
export var valOfCorrespondingType = function valOfCorrespondingType(currentColorType) {
  var index;
  switch (currentColorType) {
    case 'HEX':
      index = 0;
      break;
    case 'HSB':
      index = 1;
      break;
    case 'RGB':
      index = 2;
      break;
    case 'HSL':
      index = 3;
      break;
  }
  return index;
};
export var highlightPresetColorIndex = function highlightPresetColorIndex(color, colorArr) {
  var index = _findIndexInstanceProperty(colorArr).call(colorArr, function (val) {
    return val === color;
  });
  return index;
};
export var presetColorToHEX = function presetColorToHEX(colorArr) {
  if (!colorArr) return [];
  var hexColorArr = _mapInstanceProperty(colorArr).call(colorArr, function (color) {
    return colorFormat(color, 1, 'HEX');
  });
  return hexColorArr;
};